import React from 'react';
import '../App.css';
import {Container, Button, Row, Col} from 'reactstrap';
import {withRouter} from "react-router-dom";
import {handlePost} from "./common";

class PaymentsMarkAsPaid extends React.Component {
	constructor(props){
	   super(props);
       this.state= {
		   isLoading: false,
		   response: "Confirm",
		   dataReturned: []
	   }
	   this.handleClose = this.handleClose.bind(this);
	   this.handeSelectResponse = this.handeSelectResponse.bind(this);
	   this.handleSubmit = this.handleSubmit.bind(this);
	}
	handleClose() {
		this.props.handleClose();
	}
	handeSelectResponse() {
	}
	handleSubmit() {
		this.setState({isLoading: true});
		// field name to be determined
		var data = {"??????" : null};
		// url to be determined
		handlePost("shopify/admin/organization/update", data)
		.then(res=>res.json())
		.then((result) => {
  		   console.log(result);		
		   this.setState({isLoading: false, dataReturned: result});
		})
	}
	render() {	  
	  var responses = [
		 {"response" : "Confirm"},
		 {"response" : "Take No Action"}
 	  ];
	  return (
		  <>
			  <Container fluid>
				  <Row>
					  <div className="section-no-border-margins">
						  <Row>
							  <Col md={12} className="text-left">
								 <Row>
								    <Col md={8} className="text-left">
									   <div>
									     {['response'].map(key => (
										   <select key={key} onChange={this.handeSelectResponse} value={this.state.response} className="fields-vw">
										     {responses.map(({ [key]: value }) => <option key={value}>{value}</option>)}
										   </select>
									     ))}
									   </div>
									</Col>
								 </Row>
								 <Row className="mt-2">
								    <Col md={6} className="text-left">
										<Button type="button" size="md" color="success" className="edit-button" onClick={this.handleSubmit}>Submit</Button>{' '}
									</Col>
								    <Col md={6} className="text-left">
										<Button type="button" size="md" color="danger" className="edit-button" onClick={this.handleClose}>Cancel</Button>{' '}
									</Col>
								 </Row>
							  </Col>
						  </Row>	
				      </div>
				  </Row>
			  </Container>
		  </>
		)
	}
}

export default withRouter(PaymentsMarkAsPaid);